module.exports = __webpack_public_path__ + "static/img/img01@2x.2a1b372.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/img01@2x.png
// module id = EIwb
// module chunks = 174